import { Box, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import AdsetList from "./AdsetList";
import { StepProps } from "./CreateCampaignWizard";

const ConfirmStep = (props: StepProps) => {
  const { campaigns, campaign,  back, close, onPublish } = props;
  const campaignToUse = campaigns.find((c) => c.id === campaign?.id);
  return (
    <VStack alignItems={"start"} w="full">
      <HStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        <Text
          fontSize={"lg"}
          textTransform={"uppercase"}
          fontWeight={"bold"}
          color={"gray.400"}
        >
          Review
        </Text>
      </HStack>
      
      <AdsetList {...props} campaign={campaignToUse} />
      <HStack w="full" justifyContent={"flex-end"}>
        <Button onClick={back}>Back</Button>
        <Button onClick={close}>Save and close</Button>
        <Button onClick={() => onPublish(campaign, { publish_all_adsets: true })}>Publish</Button>
      </HStack>
    </VStack>
  );
};

export default ConfirmStep;
